import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React, { useLayoutEffect } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';
import { clearTicket, getTicketByItineraryAndSeat } from '../../../../actions';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import ResourceProperty from '../../../common/resource/ResourceProperty';
import EnumStatus from '../../../common/EnumStatus';
import { TICKET_STATUS } from '../../../../config/constants';
import { tzNormalizeDate } from '../../../../utils/date';
import { DATE_TIME_FORMAT } from '../../../../config/locale';
import { numberFormatter } from '../../../../utils/number';

const RoadBookingTicketDetails = ({
  seat,
  ticket,
  activity,
  dispatchGetTicketByItineraryAndSeat,
  dispatchClearTicket,
}) => {
  useLayoutEffect(() => {
    if (seat && seat.itineraryId && seat.seatId) {
      dispatchGetTicketByItineraryAndSeat({
        itineraryId: seat.itineraryId,
        seatId: seat.seatId,
      });
    }
    return () => {
      dispatchClearTicket();
    };
  }, [seat]);

  let content = null;

  if (activity) {
    content = <Loader />;
  } else if (ticket.isEmpty()) {
    content = <NoDataResource />;
  } else {
    const ticketDetails = ticket.toJS();
    const {
      fullDocumentCode,
      documentAssignmentDate,
      ticketStatus,
      sourceLocation,
      destinationLocation,
      departureDate,
      customer,
      listPrice,
      salePrice,
    } = ticketDetails;

    const transaction = ticketDetails.transactions && ticketDetails.transactions.length > 0
      ? ticketDetails.transactions[0]
      : {};

    const seatReservation = ticketDetails.seatReservation || {};

    content = (
      <div className="ticket-details-modal">
        <div className="mb-4">
          <h4 className="mb-3">Boleto {fullDocumentCode}</h4>
          <Row>
            <Col md={6}>
              <ResourceProperty label="Tipo de comprobante:">
                {transaction && transaction.voucherType ? transaction.voucherType.name
                  : '-'}
              </ResourceProperty>
            </Col>
            <Col md={6}>
              <ResourceProperty label="Fecha de Emisión:">
                {documentAssignmentDate
                  ? tzNormalizeDate({
                    date: documentAssignmentDate,
                    format: DATE_TIME_FORMAT,
                  })
                  : '-'}
              </ResourceProperty>
            </Col>
            <Col md={6}>
              <ResourceProperty label="Estado:">
                <EnumStatus enumObject={TICKET_STATUS} enumValue={ticketStatus} />
              </ResourceProperty>
            </Col>
          </Row>
        </div>

        <div className="mb-4">
          <h5 className="mb-3">Viaje</h5>
          <ResourceProperty label="Origen:">
            {sourceLocation.name || '-'}
          </ResourceProperty>
          <ResourceProperty label="Destino:">
            {destinationLocation.name || '-'}
          </ResourceProperty>
          <ResourceProperty label="Fecha de Salida:">
            {departureDate
              ? tzNormalizeDate({
                date: departureDate,
                format: DATE_TIME_FORMAT,
              })
              : '-'}
          </ResourceProperty>
          <ResourceProperty label="Asiento:">
            {seatReservation.seatNumber || '-'}
          </ResourceProperty>
          <ResourceProperty label="Piso:">
            {seatReservation.floorNumber || '-'}
          </ResourceProperty>
        </div>

        <div className="mb-4">
          <h5 className="mb-3">Pasajero</h5>
          <ResourceProperty label="Nombre Completo:">
            {customer.fullName || '-'}
          </ResourceProperty>
          <ResourceProperty label="Documento:">
            {customer.idDocumentNumber || '-'}
          </ResourceProperty>
          {customer.mobilePhone && (
            <ResourceProperty label="Celular:">
              {customer.mobilePhone}
            </ResourceProperty>
          )}
          {customer.email && (
            <ResourceProperty label="Email:">{customer.email}</ResourceProperty>
          )}
        </div>

        <div className="mb-3">
          <h5 className="mb-3">Pago</h5>
          <Row>
            <Col md={6}>
              <ResourceProperty label="Método de Pago:">
                {transaction && transaction.paymentMethod
                  ? transaction.paymentMethod.name
                  : '-'}
              </ResourceProperty>
            </Col>
            <Col md={6}>
              <ResourceProperty label="Precio de Lista:">
                {listPrice ? numberFormatter({ value: listPrice }) : '-'}
              </ResourceProperty>
            </Col>
            <Col md={6}>
              <ResourceProperty label="Precio de Venta:">
                <strong>
                  {salePrice ? numberFormatter({ value: salePrice }) : '-'}
                </strong>
              </ResourceProperty>
            </Col>
          </Row>
        </div>
      </div>
    );
  }

  return <div>{content}</div>;
};

RoadBookingTicketDetails.propTypes = {
  seat: PropTypes.shape({
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    itineraryId: PropTypes.number.isRequired,
    seatId: PropTypes.number.isRequired,
    seatNumber: PropTypes.number.isRequired,
  }).isRequired,
  ticket: PropTypes.instanceOf(Immutable.Map).isRequired,
  activity: PropTypes.bool.isRequired,
  dispatchGetTicketByItineraryAndSeat: PropTypes.func.isRequired,
  dispatchClearTicket: PropTypes.func.isRequired,
};

const mapStateToProps = ({ ReservationUnit }) => ({
  ticket: ReservationUnit.Ticket.getIn(['current', 'content']),
  activity: !ReservationUnit.Ticket.getIn(['current', 'activity']).isEmpty(),
});

const mapDispatchToProps = {
  dispatchGetTicketByItineraryAndSeat: getTicketByItineraryAndSeat,
  dispatchClearTicket: clearTicket,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RoadBookingTicketDetails);